module.exports = __webpack_public_path__ + "static/img/yikang.aaa289bf.png";